import { render } from "./Example6.vue?vue&type=template&id=32ac3329"
import script from "./Example6.vue?vue&type=script&lang=ts"
export * from "./Example6.vue?vue&type=script&lang=ts"
script.render = render

export default script